'use strict';
require('../../modules/es.object.assign');
var path = require('../../internals/path');

module.exports = path.Object.assign;



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/es/object/assign.js
// module id = 339
// module chunks = 0